import React from 'react';

export default function Metodology() {
  return (
    <div style={{ textAlign: 'left', margin: 'auto', width: '50%' }}>
      <h1>Metodología del proyecto</h1>
      <p>
        El proyecto se desarrollará como una PWA (Progressive Web App), aprovechando las tecnologías React y Firebase.
        Al utilizar una PWA, se obtiene la ventaja de que se comporta como una aplicación nativa, a pesar de no serlo completamente.
        Esto proporciona una gran flexibilidad y rapidez en su funcionamiento.
        React se utilizará para crear interfaces de usuario dinámicas, mientras que Firebase proporcionará flexibilidad para gestionar la base de datos,
        la autenticación y el alojamiento web mediante Firebase Hosting. Esto permitirá desplegar la PWA de forma rápida y sencilla,
        aprovechando la infraestructura confiable de Google.
      </p>
      <p>
        Las PWA ofrecen una serie de ventajas en comparación con las aplicaciones web tradicionales:
      </p>
      <ul>
        <li><strong>Fiables:</strong> Cargan rápidamente y ofrecen experiencias consistentes, incluso en conexiones de red lentas o intermitentes.</li>
        <li><strong>Rápidas:</strong> Responden rápidamente a las interacciones del usuario con animaciones fluidas y transiciones sin problemas.</li>
        <li><strong>Instalables:</strong> Se pueden instalar en el dispositivo del usuario, lo que permite un acceso rápido desde la pantalla de inicio sin necesidad de pasar por una tienda de aplicaciones.</li>
        <li><strong>Enlazables:</strong> Se pueden compartir fácilmente a través de URL, lo que facilita su distribución y accesibilidad.</li>
        <li><strong>Responsivas:</strong> Se adaptan a diferentes dispositivos y tamaños de pantalla, ofreciendo una experiencia óptima en cualquier dispositivo.</li>
      </ul>
    </div>
  );
}